/*
 *  I10DIABOUCECSCalcul.js
 *
 *  Created by Sébastien Hecart on 2017-12-13 12:44:03 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */
import { fetchTube, fetchCoefficientMajorationBatiment, fetchDebitPlomberie, fetchCanalisationDebitMinMax } from '@batical/data/src'
import i18n from '@batical/i18n'
import { RTubes_Type, RDebitPlomberieSchema_Type, RCanalisationDebitMinMaxSchema_Type, I10DIABOUCECS_State } from '@batical/types/src'

function I10DIABOUCECS_docalcul(state: I10DIABOUCECS_State) {
  state.invalidated = false
  let selectedcoeffMajoration = fetchCoefficientMajorationBatiment(state.coeffMajoration)
  let selectedtube_uuid: RTubes_Type = fetchTube(state.tube_uuid)
  let selectedcanalisationdebit_uuid: RCanalisationDebitMinMaxSchema_Type = fetchCanalisationDebitMinMax(state.canalisationdebit_uuid)
  //TODO CALCUL

  state.res_somme_debit = 0.0
  state.res_somme_debit += calculPlomberie('1', state.in_tempEauFroide, state.in_tempBouclage, state.in_evier)
  state.res_somme_debit += calculPlomberie('2', state.in_tempEauFroide, state.in_tempBouclage, state.in_lavabo)
  state.res_somme_debit += calculPlomberie('3', state.in_tempEauFroide, state.in_tempBouclage, state.in_bidet)
  state.res_somme_debit += calculPlomberie('4', state.in_tempEauFroide, state.in_tempBouclage, state.in_baignoire)
  state.res_somme_debit += calculPlomberie('5', state.in_tempEauFroide, state.in_tempBouclage, state.in_douche)
  state.res_somme_debit += calculPlomberie('6', state.in_tempEauFroide, state.in_tempBouclage, state.in_robinetdemi)
  state.res_somme_debit += calculPlomberie('7', state.in_tempEauFroide, state.in_tempBouclage, state.in_robinetquart)
  state.res_somme_debit += calculPlomberie('8', state.in_tempEauFroide, state.in_tempBouclage, state.in_lavemain)
  state.res_somme_debit += calculPlomberie('9', state.in_tempEauFroide, state.in_tempBouclage, state.in_baclaver)
  state.res_somme_debit += calculPlomberie('10', state.in_tempEauFroide, state.in_tempBouclage, state.in_linge)
  state.res_somme_debit += calculPlomberie('11', state.in_tempEauFroide, state.in_tempBouclage, state.in_vaiselle)
  //state.res_somme_debit = 60 * state.res_somme_debit;
  let sum =
    state.in_evier +
    state.in_lavabo +
    state.in_bidet +
    state.in_baignoire +
    state.in_douche +
    state.in_robinetdemi +
    state.in_robinetquart +
    state.in_lavemain +
    state.in_baclaver +
    state.in_linge +
    state.in_vaiselle
  if (sum > 0) {
    state.res_coeff_simul = (selectedcoeffMajoration.coeffMajoration * 0.8) / Math.sqrt(sum - 1)
    state.res_debit_probable = state.res_somme_debit * state.res_coeff_simul

    //=22,9*(C19/0,278)^0,4
    state.res_diam_int_probable = 22.9 * Math.pow(state.res_debit_probable / 0.278, 0.4)

    //=(C20/50)^0,5
    state.res_vitesse_sil_max = Math.pow(state.res_diam_int_probable / 50, 0.5)

    state.res_debit_max_prob = state.res_debit_probable
    //=(C24/1000)/(0,7854*C23^2)
    state.res_vitesse_debit_maxi = state.res_debit_max_prob / 1000.0 / (0.7854 * Math.pow(selectedtube_uuid.diamInt / 1000, 2))

    //=SI(H26>C25; 'VRAI'; SI(C25>C26;"diametre non conforme";"diametre conforme"))z
    if (selectedcanalisationdebit_uuid.debitMin > state.res_vitesse_debit_maxi) {
      state.res_diamConforme = i18n.t('I10DIABOUCECS_nonconforme')
    } else if (state.res_vitesse_debit_maxi > selectedcanalisationdebit_uuid.debitMax) {
      state.res_diamConforme = i18n.t('I10DIABOUCECS_nonconforme')
    } else {
      state.res_diamConforme = i18n.t('I10DIABOUCECS_conforme')
    }
  } else {
    state.res_coeff_simul = 0
    state.res_debit_probable = 0
    state.res_diam_int_probable = 0
    state.res_vitesse_sil_max = 0
    state.res_debit_max_prob = 0
    state.res_vitesse_debit_maxi = 0
    state.res_diamConforme = ''
  }
  return state
}

function calculPlomberie(type: string, tempEauFroideArrive: number, tempBouclage: number, quantite: number): number {
  let debs: RDebitPlomberieSchema_Type = fetchDebitPlomberie(type)
  const coeffDebitPrim = Math.min(1, (debs.temperature - tempEauFroideArrive) / (tempBouclage - tempEauFroideArrive))

  return quantite * debs.debit * coeffDebitPrim
}

export default I10DIABOUCECS_docalcul
